import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const RedeployIcon = (props: WrappingIconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 6.2L20.3 7.9C20.6 8.2 20.3 8.7 19.9 8.7H18V12.7C18 14.5565 17.2625 16.337 15.9497 17.6497C14.637 18.9625 12.8565 19.7 11 19.7C9.14348 19.7 7.36301 18.9625 6.05025 17.6497C4.7375 16.337 4 14.5565 4 12.7C4.02042 10.872 4.73544 9.1202 6 7.8C6.19257 7.65557 6.43078 7.58545 6.67089 7.60252C6.911 7.61958 7.1369 7.72268 7.30711 7.89289C7.47732 8.0631 7.58042 8.289 7.59748 8.52911C7.61455 8.76922 7.54443 9.00743 7.4 9.2C6.53561 10.1653 6.03981 11.4048 6 12.7C6.0256 14.0181 6.5606 15.275 7.49279 16.2072C8.42498 17.1394 9.68193 17.6744 11 17.7C12.3181 17.6744 13.575 17.1394 14.5072 16.2072C15.4394 15.275 15.9744 14.0181 16 12.7V8.7H13.9C13.5 8.7 13.2 8.2 13.5 7.9L14.9 6.2L16.5 4.2C16.5466 4.1379 16.607 4.0875 16.6764 4.05279C16.7458 4.01807 16.8224 4 16.9 4C16.9776 4 17.0542 4.01807 17.1236 4.05279C17.193 4.0875 17.2534 4.1379 17.3 4.2L19 6.2ZM12.5 13.1C12.5 13.9284 11.8284 14.6 11 14.6C10.1716 14.6 9.5 13.9284 9.5 13.1C9.5 12.2715 10.1716 11.6 11 11.6C11.8284 11.6 12.5 12.2715 12.5 13.1Z"
      />
    </Icon>
  );
};
